import KeyboardKeyIcon from '@/components/ui/keyboard-key-icon';
import { PDKAttachFileIcon } from '@/components/ui/pdk-icons';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { toast } from '@/hooks/use-toast';
import { HOTKEYS } from '@/lib/hotkeys';
import { cn } from '@/lib/utils';

const TradeUploadButton = () => {
  // const { uploadFilesMutation } = useUploadFilesToDealMutation(dealId);

  // Handle file input change
  // const handleFileInputChange = useCallback(
  //   (e: React.ChangeEvent<HTMLInputElement>) => {
  //     e.preventDefault();
  //     e.stopPropagation();

  //     toast({
  //       title: 'Uploads not implemented yet',
  //       description:
  //         "Slack us if you want the 'trade-in appraisal uploads' feature",
  //     });
  //     // if (e.target.files && e.target.files.length > 0) {
  //     //   uploadFilesMutation.mutate(e.target.files);
  //     // }
  //   },
  //   [],
  // );

  // useHotkeys(HOTKEYS.DEAL_UPLOAD_FILE, () => {
  //   document.getElementById('file-upload')?.click();
  // });

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div
          className="flex flex-col items-center justify-center space-y-2"
          onClick={() => {
            toast({
              title: 'Uploads not implemented yet',
              description:
                "Slack us if you want the 'trade-in appraisal uploads' feature",
            });
          }}
        >
          <p className="text-xs  text-gray-600">
            <label
              htmlFor="file-upload"
              className="hover:underline cursor-pointer"
            >
              <PDKAttachFileIcon
                className={cn('h-3.5 w-3.5 cursor-pointer', {})}
              />
            </label>
          </p>
          {/* <input
            id="file-upload"
            type="file"
            className="hidden"
            multiple
            onChange={handleFileInputChange}
          /> */}
        </div>
      </TooltipTrigger>
      <TooltipContent>
        <div className="flex flex-row gap-2">
          <p className="text-xs">Attach an image or file to this deal</p>
          <KeyboardKeyIcon className="w-4 h-4">
            {HOTKEYS.DEAL_UPLOAD_FILE}
          </KeyboardKeyIcon>
        </div>

        <p className="text-xs text-gray-500">
          Supported file type: PNG, JPEG, PDF, CSV, TXT
        </p>
      </TooltipContent>
    </Tooltip>
  );
};

export default TradeUploadButton;
